import { render, staticRenderFns } from "./bindingDailog.vue?vue&type=template&id=027f5aac&scoped=true"
import script from "./bindingDailog.vue?vue&type=script&lang=js"
export * from "./bindingDailog.vue?vue&type=script&lang=js"
import style0 from "./bindingDailog.vue?vue&type=style&index=0&id=027f5aac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027f5aac",
  null
  
)

export default component.exports